import React from 'react';

import { Flex, Tooltip, Typography } from 'antd';

import { CloseThisOrganisation } from './CloseThisOrganisation';
import { RestoreThisOrganisation } from './RestoreThisOrganisation';
import { usePartnerClosureRequest } from '../../api/getPartnerClosureRequest';
import { usePartnerStats } from '../../api/getPartnerStats';
import { closureRequestStatuses } from '../../types';

const { Text } = Typography;

export const PartnerClosure = () => {
  // Get Closure Request
  const { data: closureRequest } = usePartnerClosureRequest();

  const {
    data: partnerStats,
    isPending: isLoadingPartnerStats,
    isError: isErrorPartnerStats,
  } = usePartnerStats({});

  const closePartnerButtonDisable =
    partnerStats?.cannotClosePartner ||
    isLoadingPartnerStats ||
    isErrorPartnerStats;

  let children;

  if (!closureRequest) {
    return null;
  }

  if (closureRequest.status === closureRequestStatuses.Opened) {
    children = (
      <CloseThisOrganisation
        closureRequest={closureRequest}
        isLoadingPartnerStats={isLoadingPartnerStats}
        isErrorPartnerStats={isErrorPartnerStats}
        closePartnerButtonDisable={closePartnerButtonDisable}
      />
    );
  } else if (closureRequest.status === closureRequestStatuses.Approved) {
    children = <RestoreThisOrganisation closureRequest={closureRequest} />;
  }

  return (
    <Tooltip
      placement="bottom"
      color="red"
      title={
        isErrorPartnerStats ? (
          <Flex vertical>
            <Text>Error: Cannot determine if organisation can be closed. </Text>
            <Text>Please try again or contact support.</Text>
          </Flex>
        ) : undefined
      }
    >
      {children}
    </Tooltip>
  );
};
